import React, { useState } from 'react';
import { Box, Modal, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import { logos } from '../../utils/logos.js';
import { styles } from '../../assets/styles';

export default function HistoryButton({ component: HistoryComponent }) {
  const [open, setOpen] = useState(false);
  const [isHovering, setIsHovering] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleMouseOver = () => {
    setIsHovering(true);
  };

  const handleMouseOut = () => {
    setIsHovering(false);
  };

  return (
    <>
      <Button
        disableRipple
        className="history-icon-button"
        onMouseOver={handleMouseOver}
        onMouseOut={handleMouseOut}
        onClick={handleOpen}
        sx={styles.historyButton}
      >
        <img src={logos.historyIcon} alt="Stats Logo" />

        {isHovering && <Box sx={styles.buttonHoverBox}>History</Box>}
      </Button>
      <Modal open={open} onClose={handleClose} sx={styles.modalOpenHistory}>
        <Box sx={styles.historyBox1}>
          <Box sx={styles.historyBox2}>
            <Box sx={styles.historyBox3}>
              <Typography variant="h4" sx={styles.historyTypography}>
                HISTORY
              </Typography>
              {' '}
              <HistoryComponent />
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  );
}
